import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "voucher-title-wrapper" }
const _hoisted_4 = { class: "voucher-title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "pax-name" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "voucher-use-time" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "mt-1" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "border-wrap" }
const _hoisted_40 = { class: "title" }
const _hoisted_41 = {
  key: 0,
  class: "title"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = {
  key: 1,
  class: "title"
}
const _hoisted_44 = { class: "border-wrap mta4-3" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "mta4-3" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "mta4-3" }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { class: "mta4-3" }
const _hoisted_52 = { key: 3 }
const _hoisted_53 = { class: "mta4-3" }
const _hoisted_54 = { key: 4 }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refreshmentData, (data, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.detail, (dataDetail, indexDetail) => {
        return (_openBlock(), _createElementBlock("div", {
          key: indexDetail,
          class: "pagebreak"
        }, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      (_ctx.getLinkImgVoucher(_ctx.refreshmentLanguage[index], 'linkLogo', _ctx.showSecondLanguage))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                              class: "voucher-logo",
                              style: _normalizeStyle(
                  'float:' +
                  ((_ctx.refreshmentLanguage[index].paxLang.posLogo ?? _ctx.refreshmentLanguage[index].enLang.posLogo) == 'fleft'
                    ? 'left'
                    : 'right')
                )
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLinkImgVoucher(_ctx.refreshmentLanguage[index], 'linkLogo', _ctx.showSecondLanguage),
                                width: "150"
                              }, null, 8, _hoisted_2)
                            ], 4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              (_ctx.getLinkImgVoucher(_ctx.refreshmentLanguage[index], 'linkIcon', _ctx.showSecondLanguage))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.getLinkImgVoucher(_ctx.refreshmentLanguage[index], 'linkIcon', _ctx.showSecondLanguage),
                                    width: "30"
                                  }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true),
                              _createElementVNode("strong", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c1), 1)
                              ]),
                              (_ctx.showSecondLanguage)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_6,
                                    _createElementVNode("strong", null, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c1), 1)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c2), 1),
                    (_ctx.showSecondLanguage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c2), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_row, {
                    class: "mta4-3 refreshment",
                    gutter: 25
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c3), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_10,
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c3), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("p", {
                            class: "mt-1",
                            innerHTML: _ctx.languageReplace(_ctx.refreshmentLanguage[index].enLang.p2c4, { '<amount>': dataDetail.valamount })
                          }, null, 8, _hoisted_11),
                          _createElementVNode("p", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c6), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c5), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_12,
                                _hoisted_13,
                                _createElementVNode("p", {
                                  class: "mt-1",
                                  innerHTML: _ctx.languageReplace(_ctx.refreshmentLanguage[index].paxLang.p2c4, { '<amount>': dataDetail.valamount })
                                }, null, 8, _hoisted_14),
                                _createElementVNode("p", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c6), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c5), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(data.currency) + " " + _toDisplayString(dataDetail.valamount), 1),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c16), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_16,
                                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c16), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            class: "qrcode",
                            src: 'data:image/png;base64,' + data.qrCodeDetail.qr_code
                          }, null, 8, _hoisted_18),
                          _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c22) + _toDisplayString(data.qrCodeDetail.link_mobile), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_19,
                                _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c22) + _toDisplayString(data.qrCodeDetail.link_mobile), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    class: "mta4-3",
                    gutter: 20
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 12,
                        class: "refreshment"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c7), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_20,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c7), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 5,
                                class: "color-text-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.refreshmentLanguage[index].paxLang.icon_spend
                          ? _ctx.refreshmentLanguage[index].paxLang.icon_spend
                          : _ctx.refreshmentLanguage[index].enLang.icon_spend
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "ml-2 color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang?.p2c9 ?? _ctx.refreshmentLanguage[index].enLang.p2c9), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.languageReplace(_ctx.refreshmentLanguage[index].enLang.p2c15, { '<amount>': dataDetail.valamount })
                                  }, null, 8, _hoisted_22),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_23,
                                        _createElementVNode("span", {
                                          innerHTML: _ctx.languageReplace(_ctx.refreshmentLanguage[index].paxLang.p2c15, { '<amount>': dataDetail.valamount })
                                        }, null, 8, _hoisted_24)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 5,
                                class: "color-text-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.refreshmentLanguage[index].paxLang.icon_scan
                          ? _ctx.refreshmentLanguage[index].paxLang.icon_scan
                          : _ctx.refreshmentLanguage[index].enLang.icon_scan
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "ml-2",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang?.p2c10 ?? _ctx.refreshmentLanguage[index].enLang.p2c10), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c16), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_26,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c16), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 5,
                                class: "color-text-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.refreshmentLanguage[index].paxLang.icon_receipt
                          ? _ctx.refreshmentLanguage[index].paxLang.icon_receipt
                          : _ctx.refreshmentLanguage[index].enLang.icon_receipt
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "ml-2",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang?.p2c11 ?? _ctx.refreshmentLanguage[index].enLang.p2c11), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c17), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_28,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c17), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 5,
                                class: "color-text-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.refreshmentLanguage[index].paxLang.icon_bank
                          ? _ctx.refreshmentLanguage[index].paxLang.icon_bank
                          : _ctx.refreshmentLanguage[index].enLang.icon_bank
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "ml-2",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang?.p2c12 ?? _ctx.refreshmentLanguage[index].enLang.p2c12), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c18), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_30,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c18), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 5,
                                class: "color-text-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.refreshmentLanguage[index].paxLang.icon_wire
                          ? _ctx.refreshmentLanguage[index].paxLang.icon_wire
                          : _ctx.refreshmentLanguage[index].enLang.icon_wire
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "ml-2",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang?.p2c13 ?? _ctx.refreshmentLanguage[index].enLang.p2c13), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c19), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_32,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c19), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 5,
                                class: "color-text-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.refreshmentLanguage[index].paxLang.icon_receive
                          ? _ctx.refreshmentLanguage[index].paxLang.icon_receive
                          : _ctx.refreshmentLanguage[index].enLang.icon_receive
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "ml-2",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang?.p2c14 ?? _ctx.refreshmentLanguage[index].enLang.p2c14), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c20), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_34,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c20), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c23), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_35,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c23), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_36,
                          _hoisted_37,
                          _createElementVNode("p", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c24), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c24), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c25) + ":", 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c25) + ":", 1))
                              : _createCommentVNode("", true),
                            _hoisted_42,
                            _createElementVNode("p", null, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c26), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c26), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c27), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c27), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c28), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c28), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c29), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c29), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c30), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c30), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.refreshmentLanguage[index].enLang.p2c31), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.refreshmentLanguage[index].paxLang.p2c31), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", {
                              class: "mta4-3",
                              innerHTML: _ctx.languageReplace(_ctx.refreshmentLanguage[index].enLang.p2c32, { '<voucher_code>': dataDetail.voucher_code })
                            }, null, 8, _hoisted_55),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 5,
                                  innerHTML: 
                    _ctx.languageReplace(_ctx.refreshmentLanguage[index].paxLang.p2c32, { '<voucher_code>': dataDetail.voucher_code })
                  
                                }, null, 8, _hoisted_56))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]))
  }), 128))
}